export default __webpack_public_path__ + "static/media/09.df554538.jpg";